import React from "react";
import { Navigate, useParams } from "react-router";
import { InvestmentPage } from "./InvestmentPage";

export const InvestmentByParamPage = () => {
  const { investmentId, depotId } = useParams<{
    investmentId: string;
    depotId: string;
  }>();

  const parsedInvestmentId = Number(investmentId);
  const parsedDepotId = depotId ? Number(depotId) : undefined;

  if (!Number.isInteger(parsedInvestmentId)) {
    return <Navigate to="/investments" replace />;
  }

  return (
    <InvestmentPage
      investmentId={parsedInvestmentId}
      depotId={Number.isInteger(parsedDepotId) ? parsedDepotId : undefined}
    />
  );
};
